import React from 'react';
import { MTableToolbar } from 'material-table';
import { Grid, Typography, ButtonGroup, Button } from '@material-ui/core';
import ApproveDialog from 'components/FieldTests/ApproveDialog';


const withSelection = (WrappedComponent, { Form, ToolbarText, disabledCriteria = () => false, theme, allowSelectMultiple = false }) => {
  return class WithSelection extends React.Component {
    tableRef = React.createRef();
    constructor(props) {
      super(props);
      this.state = {
        selected: [],
        showApproveDialog: false
      };

      if (props.tableRef) {
        this.tableRef = props.tableRef;
      };
    }

    setSelected = (e) => { this.setState({ selected: e }) };

    setShowApproveDialog = (e) => { this.setState({ showApproveDialog: e }) };

    toolbarStyle = {
      padding: 12,
      background: theme.palette.secondary.light
    }

    Form = () => Form(
      {
        rowData: this.state.selected,
        submit: async (e) => {
          setTimeout(() => {
            this.setSelected([]); this.setShowApproveDialog(false);
            this.tableRef.current.onQueryChange();
          }, 800);
          return { success: true }
        },
        onCancel: () => this.setShowApproveDialog(false),
      }
    )

    render() {

      const extendProps = {
        options: {
          ...this.props.options,
          selection: true,
          showSelectAllCheckbox: false,
          showTextRowsSelected: false,
          selectionProps: rowData => {
            if (this.state.selected.length > 0) {
              const inSelection = this.state.selected.find(r => r.tableData.id === rowData.tableData.id);
              if (!allowSelectMultiple) {
                return {
                  disabled: !inSelection,
                  checked: !!inSelection
                }
              } else {
                return {
                  disabled: disabledCriteria(rowData),
                  checked: !!inSelection
                }
              }
            } else {
              return {
                disabled: disabledCriteria(rowData),
                checked: false
              };
            }
          }
        },
        onSelectionChange: (a, b, c) => { a.length > 0 ? allowSelectMultiple ? this.setSelected(a) : this.setSelected([b]) : this.setSelected([]); },
        components: {
          Toolbar: props => (
            <>
              <MTableToolbar {...props} />
              {this.state.selected.length > 0 && <div>
                <Grid container alignItems="center" style={{ display: 'flex', verticalAlign: 'middle', ...this.toolbarStyle }}>
                  <Grid item xs={6}>
                    <Typography variant="h6">{ToolbarText}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                  </Grid>
                  <Grid item xs={3} style={{ textAlign: "right" }}>
                    <ButtonGroup variant="contained" color="primary" aria-label="text primary button group" size="large" >
                      <Button onClick={() => this.setShowApproveDialog(true)}>Yes</Button>
                      <Button
                        onClick={
                          () => {
                            this.setState({ selected: [] });
                            if (this.tableRef.current && this.tableRef.current.dataManager) {
                              this.tableRef.current.dataManager.changeAllSelected && this.tableRef.current.dataManager.changeAllSelected(false);
                              this.tableRef.current.onSelectionChange && this.tableRef.current.onSelectionChange(false);
                            }
                          }
                        }>Cancel</Button>
                    </ButtonGroup>
                  </Grid>
                </Grid>
              </div>
              }
            </>
          ),
        }
      }

      return (
        <>
          <WrappedComponent tableRef={this.tableRef} {...this.props} {...extendProps} actions={[]} />
          <ApproveDialog
            Form={this.Form}
            show={this.state.showApproveDialog}
          />
        </>
      )
    }
  }
}

export default withSelection;